"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHSimpleListMenu = void 0;
const KHContainer_1 = require("../KHContainer");
const KHListInputHandler_1 = require("./KHListInputHandler");
const KHMenuSpec_1 = require("./KHMenuSpec");
class KHSimpleListMenu extends KHContainer_1.KHContainer {
    /**
     * Creates a new KHSimpleListMenu. You must call update on this class each frame.
     *
     * @param scene Scene the view will be added to.
     * @param inputHandler Input handler. Should define keys for "left", "right", "up", "down", and "back". This script will own the lifecycle of input listening.
     * @param menuSpec Spec for the menu to be created.
     * @param rect Space the view should take up.
     * @param elementHeight Height of each element in the list view.
     * @param scrollRect Space the scrollView should take up.
     * @param extraObjects Other objects to add to the container.
     * @param optionCreationCallback Way to specify the type of menu object created.
     * * @param descriptionUpdateCallback Called when the title is updated.
     * @param descriptionUpdateCallback Called when description is updated.
     */
    constructor(scene, registrar, inputHandler, menuSpec, rect, extraObjects, optionCreationCallback, titleUpdateCallback, descriptionUpdateCallback = null) {
        super(scene, rect.x, rect.y, rect.width, rect.height);
        this.updateCalled = false;
        this.inputHandler = inputHandler;
        this.inputHandler.register(registrar);
        // If the scene shuts down, stop listening on the inputHandler to 
        // prevent inputs for shadow objects.
        scene.events.on('shutdown', () => {
            this.inputHandler.unregister();
        });
        extraObjects === null || extraObjects === void 0 ? void 0 : extraObjects.forEach(element => {
            this.add(element);
        });
        scene.time.delayedCall(1000, () => {
            if (!this.updateCalled) {
                console.warn("List existed for a second without having update called on it. Non-mouse input will not work.");
            }
        });
        this.optionCreationCallback = optionCreationCallback;
        this.descriptionUpdateCallback = descriptionUpdateCallback;
        this.menuSpec = menuSpec;
        this.menuSpec.registerCallback(KHMenuSpec_1.KHMenuSpec.UPDATE_DESCRIPTION, (data) => {
            this.sendUpdateDescription(data.description);
        });
        this.menuSpec.getOptions().forEach((value) => {
            this.addMenuOption(value, false);
        });
        this.addMenuOption(this.menuSpec.getLastOption(), true);
        if (titleUpdateCallback) {
            titleUpdateCallback(this.menuSpec.title);
        }
        this.sendUpdateDescription(this.menuSpec.getDescription());
    }
    sendUpdateDescription(text) {
        if (this.descriptionUpdateCallback) {
            this.descriptionUpdateCallback(text);
        }
    }
    destroy() {
        this.inputHandler.unregister();
        super.destroy();
    }
    update(now) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.updateCalled = true;
        if ((_a = this.inputHandler) === null || _a === void 0 ? void 0 : _a.isJustDown(KHListInputHandler_1.KHListInputs.Left)) {
            this.menuSpec.sendSelectPreviousToCurrentOption();
        }
        if ((_b = this.inputHandler) === null || _b === void 0 ? void 0 : _b.isJustDown(KHListInputHandler_1.KHListInputs.Right)) {
            this.menuSpec.sendSelectNextToCurrentOption();
        }
        if ((_c = this.inputHandler) === null || _c === void 0 ? void 0 : _c.isJustDown(KHListInputHandler_1.KHListInputs.Down)) {
            this.menuSpec.setNextIndex();
        }
        if ((_d = this.inputHandler) === null || _d === void 0 ? void 0 : _d.isJustDown(KHListInputHandler_1.KHListInputs.Up)) {
            this.menuSpec.setPreviousIndex();
        }
        if ((_e = this.inputHandler) === null || _e === void 0 ? void 0 : _e.isJustDown(KHListInputHandler_1.KHListInputs.Back)) {
            if ((_f = this.menuSpec.getLastOption()) === null || _f === void 0 ? void 0 : _f.callback) {
                (_g = this.menuSpec.getLastOption()) === null || _g === void 0 ? void 0 : _g.callback();
            }
        }
    }
    addMenuOption(menu_option, last = false) {
        if (menu_option == null) {
            return;
        }
        const text_obj = this.optionCreationCallback(menu_option, () => this.menuSpec.setSelected(menu_option), () => this.menuSpec.setSelected(null), () => this.menuSpec.sendSelectNextToCurrentOption(), () => this.menuSpec.sendSelectPreviousToCurrentOption(), (bounds, buffer) => {
        });
        this.scene.add.existing(text_obj);
        this.add(text_obj);
    }
}
exports.KHSimpleListMenu = KHSimpleListMenu;
